export default __webpack_public_path__ + "static/wsg-4f8f51eb7481526107e9b9e97df53ccd.jpg";